import { Component } from 'react';
import Information from '../modules/Information';

export default class NoscriptAlert extends Component {
  /**
   *
   */
  public render() {
    return (
      <noscript>
        <Information
          isShow={true}
          variant="warning"
          title="現在JavaScriptが無効になっています"
          text="Yahoo!ニュースのすべての機能を利用するためには、JavaScriptの設定を有効にしてください。"
          linkURL="https://support.yahoo-net.jp/noscript"
          linkText="JavaScriptの設定を変更する方法はこちら"
        />
      </noscript>
    );
  }
}
